// ./src/components/features/Connectors/ConnectorCategoryBadge.tsx
import React from "react";
import { Badge } from "@mantine/core";
import {
  CONNECTOR_CATEGORIES,
  CONNECTOR_CATEGORY_LABELS,
} from "@/config/connectorCategories";

export interface ConnectorCategoryBadgeProps {
  /** Category value */
  category: string | null | undefined;

  /** Badge size */
  size?: "xs" | "sm" | "md" | "lg" | "xl";

  /** Badge variant */
  variant?: "filled" | "light" | "outline" | "dot" | "default";
}

// Colors for different categories
const CATEGORY_COLORS: Record<string, string> = {
  [CONNECTOR_CATEGORIES.WEBHOOKS]: "blue",
  [CONNECTOR_CATEGORIES.DATA_STORAGE]: "purple",
  [CONNECTOR_CATEGORIES.FILES_STORAGE]: "violet",
  [CONNECTOR_CATEGORIES.MESSENGERS]: "green",
  [CONNECTOR_CATEGORIES.CRM]: "orange",
};

export const ConnectorCategoryBadge: React.FC<ConnectorCategoryBadgeProps> = ({
  category,
  size = "sm",
  variant = "light",
}) => {
  if (!category) {
    return (
      <Badge color="gray" size={size} variant={variant}>
        Unknown
      </Badge>
    );
  }

  const label = CONNECTOR_CATEGORY_LABELS[category] || category;
  const color = CATEGORY_COLORS[category] || "gray";

  return (
    <Badge color={color} size={size} variant={variant}>
      {label}
    </Badge>
  );
};
